/*******************************************************************************
  설  명 : 시크릿페이지 -  우아한형제들 1000원 이벤트용
  생성일 : 2025-04-07
  생성자 : 권세창
*******************************************************************************/
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '@app/service/auth.service';
import { SEventService } from '@app/service/event.service';

@Component({
  selector: 'app-secret-event',
  templateUrl: './secret-event.component.html',
  styleUrls: ['./secret-event.component.scss']
})
export class SecretEventComponent implements OnInit {
  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/

  public isLogIn: boolean;
  isLogin$: Observable<boolean>; // 로그인여부확인

  public eachEventList: any = [];
  eventOrderCount: number | null = null;


  public search: any = {
    seq: '653',
    pageNo: 1,
    pageRow: 12,
    sort: 1
  };
  resultSort = 1; // 결과값 sort
  viewType = 1; // 상품조회 type

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/

  constructor(
    private authService: AuthService,
    private router: Router , // ← 리다이렉트용 Router 주입
    private sEventService: SEventService,
    private toastrService: ToastrService,
  ) { 
    // 로그인 여부 가져오기
    this.isLogin$ = this.authService.isLoggedIn;

    this.isLogin$.subscribe( login => {
      this.isLogIn = login;

      // 로그인 되지 않았으면 로그인 페이지로 라우팅 

      // 로컬에서 테스트를 위해 임시로 막음
//       if (!login) {
//         this.router.navigate(['/member/login']); // 로그인 페이지로 이동
//       }

    });
  }

  ngOnInit(): void {

   this.getEventOrderCount();
 //  this.eventOrderCount = 1;
   if (this.eventOrderCount < 1) { 
     this.getSecretEventProductList();
   }
  }


  getImageSrc(item: any): string {
    return item.imageSrc || item.thumbnail_url_shack || item.thumbnail_url;
  }

  /**
   * 이미지 로딩 실패 시 실행되는 함수
   * thumbnail_url_shack가 깨진 경우 thumbnail_url로 변경
   */
  onImageError(item: any): void {
    if (item.imageSrc !== item.thumbnail_url) {
      item.imageSrc = item.thumbnail_url ||'https://shop.bikemart.co.kr/assets/images/logo.png';
    }
  }

  /*******************************************************************************
    설  명 : 이벤트 참여여부 확인
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
    getEventOrderCount() {
      this.sEventService.getEventOrderCount( this.search ).then(response => {
        if ( response.ResultCode ) {
          this.eventOrderCount = response.count;
        } else {
          this.toastrService.error(response.ResultMessage);
        }
      });
    }    

  /*******************************************************************************
    설  명 : 이벤트상품리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
    getSecretEventProductList() {
      this.sEventService.getSecretEventProductList( this.search ).then(response => {
        if ( response.ResultCode ) {
          this.eachEventList = response.data;
        } else {
          this.toastrService.error(response.ResultMessage);
        }
      });
    }  

  /*******************************************************************************
    설  명 : ngif 크기비교 int로 변환
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
    comparePrice(a, b) {
      let c = parseInt(a);
      let d = parseInt(b);
      if ( c > d) {
        return true;
      } else {
        return false;
      }
    }

}
